export default function PremiumTrialCTA() {
  return (
    <section className="relative pt-20 md:pt-24 pb-3 md:pb-4 z-10 bg-secondary-950" aria-label="Free trial offer">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-5 py-3.5 md:py-4 px-4 md:px-6 rounded-2xl bg-white/[0.06] backdrop-blur-md border border-white/[0.10]">
          {/* Left: Badge + Text */}
          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-400/30 text-xs font-semibold text-accent-300 whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400" aria-hidden="true"></span>
              FREE 7-Day Trial
            </span>
            <div className="text-center sm:text-left">
              <p className="text-sm md:text-base font-semibold text-white font-heading">
                Start Automating Your Business Today
              </p>
              <p className="text-xs md:text-sm text-white/55 mt-0.5">
                Experience Digi Flow completely free for 7 days. No Credit Card Required. Setup in Minutes. Cancel Anytime.
              </p>
            </div>
          </div>

          {/* Right: Buttons */}
          <div className="flex items-center gap-3 w-full md:w-auto">
            <a
              href="https://automate.dgflow.in/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex-1 md:flex-none inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-400 transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] whitespace-nowrap shadow-md shadow-primary-500/25"
            >
              <i className="ri-rocket-line group-hover:-translate-y-px transition-transform"></i>
              Start FREE Trial
            </a>
            <a
              href="#hero"
              className="hidden sm:inline-flex items-center gap-1 text-xs font-medium text-white/50 hover:text-white/85 transition-colors whitespace-nowrap"
            >
              Learn More
              <i className="ri-arrow-down-line animate-bounce"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}